// Gate for authenticated-only routes. Shows a spinner while the session is being established,
// then either renders the page or redirects to /login.
import { Navigate, useLocation } from 'react-router-dom';
import { rememberReturn } from '../lib/returnTo.js';
import { useAuthStore } from '../stores/authStore.js';
import Spinner from './Spinner.jsx';

export default function ProtectedRoute({ children }) {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();
  if (status === 'loading') return <Spinner full />;
  if (status !== 'authenticated') {
    rememberReturn(location.pathname + location.search); // back here after signing in
    return <Navigate to="/login" replace />;
  }
  return children;
}
